import type { TOC } from '@ember/component/template-only';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

interface NoReviewPermissionTooltipSignature {
  Element: HTMLSpanElement;
}

<template>
  <span class="icon-info inline-block !align-middle !h-4 !w-4 !ml-2" alt="info" ...attributes>
    {{! prettier-ignore }}
    <EmberTooltip
      @side="left"
      @tooltipClass="!rounded-none !p-2 !border !border-carbon-20 !text-carbon-80 !bg-white text-shadow-none z-50 !max-w-xs [&_.ember-tooltip-arrow]:hidden"
    >
      <span data-test-no-review-permission-message>
        You're assigned to this step but your role doesn't include the correct permission. Ask a Global admin to update your role.
      </span>
    </EmberTooltip>
  </span>
</template> satisfies TOC<NoReviewPermissionTooltipSignature>;
